import React, {useCallback, useEffect, useState} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
import BodyTemplate from "../BodyTemplate/BodyTemplate";
import Aux from "../../../hoc/Auxiliary";
import {MultiSelect} from "primereact/multiselect";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import TemplatePaginator from "../../commun/TemplatePaginator/TemplatePaginator";
import classes from "../../DataCollection/DataCollections/DataCollectionList.module.css";
import {canUploadData} from "../../../api/authorization/rules";
import {getUniqueObjectsByProperty} from "../../../api/utils/UniqueObjectsByProperty";
import {MeterGroup} from "primereact/metergroup";

const DetailsTable = (marketNodesDetails) => {
    const [rows, setRows] = useState(20);
    const [first, setFirst] = useState(0);
    const [status, setStatus] = useState([]);
    const [filters, setFilters] = useState({});
    const [isMCResultButtonDisable, setIsMCResultButtonDisable] = useState(true);
    const [expandedMarketNodes, setExpandedMarketNodes] = useState({});
    const [dataCollection, setDataCollection] = useState(marketNodesDetails.dataCollection);
    const [marketNodesData, setMarketNodesData] = useState(marketNodesDetails.marketNodesDetails);
    const [value, setValue] = useState();

    const initFilters = () => {
        setFilters({
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},
            "marketNodeStatus.name": {value: null, matchMode: FilterMatchMode.IN},
            "marketNode.name": {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            lastEditSort: {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
            },
            lastStatusChangeSort: {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
            },
            lastChangedBy: {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            }
        });
    };

    const parseDate = (value) => {
        if (!value) {
            return null;
        }
        const [datePart, timePart] = value.split(" ");
        if (!datePart || !timePart) {
            return null;
        }
        const [day, month, year] = datePart.split("/").map(Number);
        const [hours, minutes] = timePart.split(":").map(Number);
        const date = new Date(year, month - 1, day, hours, minutes);
        return isNaN(date.getTime()) ? null : date;
    };

    const tableData = marketNodesData.map((row) => ({
        ...row,
        lastStatusChangeSort: parseDate(
            row.lastStatusChange
        ),
        lastEditSort: parseDate(
            row.lastEdit
        )
    }));

    useEffect(() => {
        setMarketNodesData(marketNodesDetails.marketNodesDetails);
        setDataCollection(marketNodesDetails.dataCollection);
        setIsMCResultButtonDisable(!isMCResultButtonDisable)
    }, [marketNodesDetails])
    const onFilter = (e) => {
        let result = marketNodesDetails.marketNodesDetails.filter(e1 =>
            e.value.map(v => v.code)
                .some(val => e1['marketNodeStatus'].code
                    .includes(val)))
        if (e.value.length === 0) {
            setMarketNodesData(marketNodesDetails.marketNodesDetails);
        } else {
            setMarketNodesData(result);
        }
        setValue(e.value);
    };


    const onCustomPage = useCallback((event) => {
        setFirst(event.first);
        setRows(event.rows);
    }, [])


    useEffect(() => {
        let st = marketNodesData.map((mn) => mn['marketNodeStatus']);

        setStatus(getUniqueObjectsByProperty(st, "name"));
        initFilters();
    }, [])


    const statusFilterTemplate = () => {
        return <MultiSelect value={value} options={status}
                            onChange={onFilter}
                            optionLabel="name" placeholder="Select a status" className="p-column-filter"/>;
    }

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) =>
                    options.filterCallback(
                        e.value,
                        options.index)
                }
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
                showButtonBar
            />
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="vertical-align-middle ml-2"> {rowData['marketNodeStatus'].name}</span>
            </React.Fragment>
        );
    }
    const marketNodeDetailsTemplate = (data) => {
        return (
            <div className="p-3">
                {data.manualCheck.reason !== "" &&
                    <div className={classes.description}><h5>Manual check details :</h5>{data.manualCheck.reason}</div>}
            </div>
        );
    };
    const allowExpansion = (rowData) => {
        return rowData.manualCheck.reason !== "" && canUploadData(dataCollection.participants, rowData.marketNode);
    };

    function calculateProgressValues(progressInfos) {
        if (progressInfos.length === 0) {
            return [{color: 'gray', value: 0}]
        } else {
            return progressInfos.map(x => {
                return {'color': x.color, "value": x.percentage}
            });
        }

    }

    const validationProgress = (row) => {
        const wrapperClass =
            row["marketNodeStatus"].code === "TECHNICAL_ISSUE"
                ? "meter-wrapper-tech"
                : "meter-wrapper-normal";
        return (
            <div className={wrapperClass}>
                <MeterGroup
                    style={{width: "100%"}}
                    values={calculateProgressValues(row["progressInfos"])}
                />
            </div>
        );
    };
    return (
        <Aux>
            <div>
                <div className=" card">

                    <DataTable
                        expandedRows={expandedMarketNodes} onRowToggle={(e) => {
                        setExpandedMarketNodes(e.data)
                    }}
                        removableSort
                        rowExpansionTemplate={marketNodeDetailsTemplate}
                        expandedRowIcon="pi pi-chevron-up"
                        collapsedRowIcon="pi pi-chevron-down"
                        dataKey="id"
                        tableClassName="justify-content-center"
                        value={tableData}
                        size="small"
                        resizableColumns
                        stripedRows
                        showGridlines
                        paginator
                        paginatorTemplate={TemplatePaginator}
                        first={first}
                        rows={rows}
                        onPage={onCustomPage}
                        filters={filters}
                        filterDisplay="menu"
                        paginatorClassName="justify-content-end" className="mt-6"
                    >
                        <Column expander={allowExpansion} style={{minWidth: '2rem', maxWidth: '2rem'}}/>
                        <Column sortable field="marketNode.name" header=" Market node"
                                style={{minWidth: "10rem"}} filter/>
                        <Column sortable filterField="marketNodeStatus.name"
                                header="Last Status"
                                filterMenuStyle={{width: '14rem', height: '6rem'}}
                                style={{minWidth: '10rem', whiteSpace: 'normal', wordWrap: 'break-word'}}
                                showFilterMatchModes={false}
                                body={statusBodyTemplate}
                                filter
                                showApplyButton={false}
                                showClearButton={false}
                                filterElement={statusFilterTemplate}
                        />
                        <Column sortable field="lastStatusChangeSort" header="Last Status Change"
                                style={{minWidth: '10rem'}} filter
                                filterField="lastStatusChangeSort"
                                filterMatchMode={FilterMatchMode.DATE_IS}
                                filterElement={dateFilterTemplate}
                                body={(rowData) => rowData.lastStatusChange}
                        />
                        <Column header="Validation Progress"
                                style={{minWidth: '10rem'}}
                                body={validationProgress}
                        />
                        <Column sortable field="version" header="Version" style={{minWidth: '10rem'}} filter/>
                        {dataCollection.dataCollectionType.code === "IGM" &&
                            <Column sortable field="lastSubmittedFileName" header={"Last Submitted File Name"}
                                    style={{minWidth: '12rem'}} headerClassName={classes.wrapText}
                                    bodyClassName={classes.wrapText} filter/>}
                        <Column sortable field="lastEditSort" header="Last Edit" style={{minWidth: '10rem'}} filter
                                filterField="lastEditSort"
                                filterMatchMode={FilterMatchMode.DATE_IS}
                                filterElement={dateFilterTemplate}
                                body={(rowData) => rowData.lastEdit}/>
                        <Column sortable field="lastChangedBy" header="Last changed by"
                                style={{minWidth: '12rem'}} filter/>
                        <Column header="Actions" body={r => BodyTemplate({
                            "dataCollection": marketNodesDetails.dataCollection,
                            "marketNodeData": r
                        })} style={{minWidth: '10rem'}}
                                headerStyle={{minWidth: "10rem"}} alignHeader={"center"}/>
                    </DataTable>
                </div>
            </div>
        </Aux>
    )
}

export default DetailsTable;
